<template>
  <div class="view">
    <Title title="イベント"/>
    <EventMain/>
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import EventMain from '@/components/EventMain'

export default {
  components: {
    Title,
    EventMain
  },
  created: function () {
    this.$store.dispatch('event/retrieveEvents')
  }
}
</script>
